import { NgModule, Optional, SkipSelf } from "@angular/core";

import { RuntimeConfigModule } from "@lantern/app/core/utils/runtime-config";

import { GlobalAuthApi } from "./global-auth-api.service";

@NgModule({
  imports: [RuntimeConfigModule],
  providers: [GlobalAuthApi]
})
export class GlobalAuthApiModule {
  constructor(@Optional() @SkipSelf() guard?: GlobalAuthApiModule) {
    if (guard != null) {
      throw new Error(
        "GlobalAuthApiModule is already loaded. Import it in the root module only."
      );
    }
  }
}
